import UploadImage from "../../molecules/UploadImage";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import api from "../../../Api";

interface SidePopUpProps {
  Title?: string;
  SubTitle?: string;
  isPopUpOpen: boolean;
  bigImage? : boolean;
  SubmitButtonText?: string;
  onClose: () => void;
  onPortfolioUpdate?: () => void;
}

interface Portfolios {
  img: string;
}

export default function AddPortfoliosPopUp({
  Title = "Add Portfolios",
  SubTitle = "Add images you want to add for the word of portfolio section",
  isPopUpOpen = false,
  SubmitButtonText = "Add a Image",
  bigImage = false,
  onClose,
  onPortfolioUpdate,
}: SidePopUpProps) {
  const [uploadedImage, setUploadedImage] = useState<File | string>("");
  const [error, setError] = useState("");

  const popupRef = useRef<HTMLDivElement>(null);

  const handleImageUpload = (file: File) => {
    setUploadedImage(file); // Accept the file object
  };

  const handleSubmit = async () => {
    if (!uploadedImage || typeof uploadedImage === "string") {
      alert("Please upload an image.");
      return;
    }

    const formData = new FormData();
    formData.append("file", uploadedImage);

    try {
      const uploadResponse = await axios.post(api.uploadFile, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (uploadResponse.data.success) {
        const uploadedImageUrl = uploadResponse.data.url;

        // Generate a unique ID for the new testimonial (you can change this logic as needed)
        const portfolioData: Portfolios = {
          img: uploadedImageUrl,
        };

        const response = await axios.post(
          api.deleteAndAddImage,
          portfolioData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          onClose();
          onPortfolioUpdate?.();
        } else {
          setError("Something went wrong");
        }
      } else {
        setError("Something went wrong");
      }
    } catch (error) {
      console.error("Error adding testimonial:", error);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    if (isPopUpOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isPopUpOpen, onClose]);

  return (
    <div
      ref={popupRef}
      className={`bg-white border-l space-y-4 py-4 fixed z-10 ${
        isPopUpOpen ? "right-0" : "right-[-500px]"
      } h-full duration-300 w-[400px]`}
    >
      <div className="px-4 space-y-4">
        <div className="space-y-2">
          <h1 className="font-primary text-title">{Title}</h1>
          <p className="text-black/[.60]">{SubTitle}</p>
        </div>

        <UploadImage
          ButtonText="Upload an image"
          bigImage={bigImage}
          onUpload={handleImageUpload} // Pass the file object to the parent
        />
      </div>

      <hr />

      <div className="flex items-center justify-end space-x-4 px-4">
        <p onClick={onClose} className="text-black/[.60] cursor-pointer">
          cancel
        </p>
        <div
          onClick={handleSubmit}
          className="bg-primary text-white hover:bg-primary_dark duration-300 p-2 px-4 rounded hover:cursor-pointer"
        >
          <p>{SubmitButtonText}</p>
        </div>
      </div>

      {error && <div className="text-red-500 text-center mt-2">{error}</div>}
    </div>
  );
}
